import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { Menu, Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PUBLIC_NAV = [
  { to: "/yazilar" as const, label: "Yazılar" },
  { to: "/sozluk" as const, label: "Sözlük" },
  { to: "/cop31" as const, label: "COP31" },
  { to: "/kitaplar" as const, label: "Kitaplar" },
  { to: "/yazar" as const, label: "Hakkında" },
];

/** The single Turkish site header (homepage design), shared by every public page. */
export function PublicHeader({ bordered = true }: { bordered?: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <header className={`relative z-30 bg-paper ${bordered ? "border-b border-ink/10 pb-4 lg:pb-5" : ""}`}>
      <div className="mx-auto grid grid-cols-[minmax(0,1fr)_auto] max-w-7xl items-start gap-3 px-5 pt-4 sm:flex sm:justify-between sm:px-8 lg:pt-6">
        <Link to="/" className="min-w-0 font-serif text-ink" aria-label="Akıllı Sürdürülebilirlik — ana sayfa">
          <span className="block text-[19px] font-semibold leading-[0.95] tracking-normal sm:text-[26px]">
            Akıllı<br />Sürdürülebilirlik
          </span>
          <span className="mt-1.5 block text-[8.5px] uppercase leading-snug tracking-[0.22em] text-ink/80 sm:text-[10px]">
            Daha iyi bir yarın için<br />daha derin düşünmek
          </span>
        </Link>
        <nav aria-label="Ana menü" className="hidden items-center gap-10 pt-2 font-serif text-[15px] text-ink md:flex">
          {PUBLIC_NAV.map((n) => (
            <Link key={n.to} to={n.to} className="hover:text-clay transition-colors" activeProps={{ className: "underline underline-offset-8 decoration-ink/40" }}>
              {n.label}
            </Link>
          ))}
          <span aria-hidden className="h-6 w-px bg-ink/20" />
          <Link to="/search" aria-label="Ara" className="p-1 hover:text-clay transition-colors">
            <Search className="size-5" />
          </Link>
        </nav>
        <div className="flex shrink-0 items-center gap-1 md:hidden">
          <Link to="/search" aria-label="Ara" className="grid size-11 place-items-center text-ink">
            <Search className="size-5" />
          </Link>
          <Button
            variant="ghost"
            type="button"
            aria-label={open ? "Menüyü kapat" : "Menüyü aç"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="grid size-11 place-items-center text-ink"
          >
            {open ? <X className="size-5" /> : <Menu className="size-5" />}
          </Button>
        </div>
      </div>
      {open && (
        <nav aria-label="Mobil menü" className="absolute inset-x-0 top-full border-y border-border bg-paper md:hidden">
          <ul className="mx-auto flex max-w-7xl flex-col px-5 py-2 font-serif text-lg">
            {PUBLIC_NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} onClick={() => setOpen(false)} className="block py-3 text-ink">{n.label}</Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
}
